import { render, staticRenderFns } from "./ObjectEditAndReplace.vue?vue&type=template&id=dbc799dc&scoped=true&"
import script from "./ObjectEditAndReplace.vue?vue&type=script&lang=js&"
export * from "./ObjectEditAndReplace.vue?vue&type=script&lang=js&"
import style0 from "./ObjectEditAndReplace.vue?vue&type=style&index=0&id=dbc799dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc799dc",
  null
  
)

export default component.exports